import { render } from "./VsTd.vue?vue&type=template&id=6d4896a2"
import script from "./VsTd.vue?vue&type=script&lang=js"
export * from "./VsTd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__